import type { AboveInputContainerProps } from '..'
import type { Tokens } from '../../../../theming/types'

export default (config: {
  props: Partial<AboveInputContainerProps>
  tokens: Tokens
}) => {
  const { props, tokens } = config
  return {
    wrap: {
      marginBlockEnd:
        !props.hideLabel || props.description ? tokens.spacingGap50 : undefined,
    },
  } as const
}
